import { BELGE_GRUBUNA_GORE_ALT_SUREC_BASVURU_SAYILARI } from "../constants/requestUrls";
import { postRequest } from "../request";

const altSurecBasvuruSayilari  = (tempBelgeGrubuId) => {
    let filterModel= {};
    filterModel.BelgeGrubuId=tempBelgeGrubuId;
    const data = JSON.stringify(filterModel);
    return postRequest({url:BELGE_GRUBUNA_GORE_ALT_SUREC_BASVURU_SAYILARI,data});
}

export default altSurecBasvuruSayilari ;